<script setup lang="ts">
interface Props {
  variant?: 'default' | 'bordered' | 'elevated'
  padding?: 'none' | 'sm' | 'md' | 'lg'
  hoverable?: boolean
  clickable?: boolean
}

withDefaults(defineProps<Props>(), {
  variant: 'bordered',
  padding: 'md',
})

defineEmits<{
  (e: 'click'): void
}>()
</script>

<template>
  <div
    class="aw-card"
    :class="[
      `aw-card--${variant}`,
      `aw-card--padding-${padding}`,
      { 'aw-card--hoverable': hoverable, 'aw-card--clickable': clickable },
    ]"
    @click="clickable ? $emit('click') : undefined"
  >
    <slot />
  </div>
</template>

<style scoped>
.aw-card {
  background-color: var(--aw-bg-base);
  border-radius: var(--aw-radius-lg);
  transition: all var(--aw-duration-normal) var(--aw-ease-out);
}
.aw-card--bordered {
  border: 1px solid var(--aw-border-default);
}
.aw-card--elevated {
  box-shadow: var(--aw-shadow-md);
}
.aw-card--padding-none {
  padding: 0;
}
.aw-card--padding-sm {
  padding: var(--aw-space-3);
}
.aw-card--padding-md {
  padding: var(--aw-space-4);
}
.aw-card--padding-lg {
  padding: var(--aw-space-6);
}
.aw-card--hoverable:hover {
  transform: translateY(-2px);
  box-shadow: var(--aw-shadow-lg);
}
.aw-card--clickable {
  cursor: pointer;
}
.aw-card--clickable:hover {
  border-color: var(--aw-primary-300);
}
</style>